import React, { useState, useContext } from "react";
import { EstaSinLuzContext, } from "../../context/EstaSinLuzContextProvider";
import { Formik } from 'formik';
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";
import Loading from "../../../../common/components/Loading";
import { useModal } from "@clayui/modal";
import AlertModal from "../../../../common/components/AlertModal";
import { CGE } from "../../../../common/components/CGE";
import { isRutValid, beforeMaskedValueChangeRut } from "../../../../common/utils/utilsFunc";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const FormContingency = ({ msgAlert, showAlert, state, funcClick, setForm, showLoad}) => {
    const properties = useContext(ApplicationPropertiesContext);
    const [verifReCaptcha, setVerifReCaptcha] = useState(false);
    const [emptyInput, setEmptyInput] = useState(false);
    const [validatedInput, setValidatedInput] = useState(false);
    const [stateNoLight] = useContext(EstaSinLuzContext);
    const [visibleModal, setVisibleModal] = useState(false);
    const [buttonHandleClick, setButtonHandleClick] = React.useState(false)
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        }
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    let optionsPresentacion = [
        { value: "0", label: '(Seleccione una opción)' },
    ]

    if (stateNoLight.tipoPresentacion.presentaciones) {
        stateNoLight.tipoPresentacion.presentaciones.forEach((item) => {
            optionsPresentacion.push({ label: item.nombre, value: item.codigoSap })
        })
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleClickButton() {
        if (emptyInput || validatedInput) {
            setButtonHandleClick(true)
        } else {
            setButtonHandleClick(false)
        }

        if (emptyInput) {
            properties.setGlobalAlert("Complete todos los campos obligatorios.", "warning")
        } else if (!emptyInput && !verifReCaptcha) {
            properties.setGlobalAlert('Falta validar que no eres un Robot.', "warning")
        }

    }

    return (
        <Formik
            validateOnChange={true}
            validateOnBlur={true}
            validateOnMount={true}
            initialValues={{
                CuentaContrato: state?.idCtaCto,
                Empresa: properties.codigo_empresa,
                OrigenReclamo: "Página Web",
                CdgTipoReclamo: '0',
                OfrecePeligro: '',
                Comuna: state?.estaSinLuz?.comuna,
                CdgComuna: state?.estaSinLuz?.codigoComuna,
                Calle: state?.estaSinLuz?.dirCalle,
                NroCalle: state?.estaSinLuz?.dirNumero,
                Dpto: state?.estaSinLuz?.dirDpto,
                NombReclamante: '',
                RUTReclamante: '',
                TelefReclamante: '',
                CelularReclamanete: '',
                EmailReclamante: '',
                Observacion: '',
                Instalacion: state?.estaSinLuz?.instalacion,
                InterlocutorComercial: state?.estaSinLuz?.interlocutorComercial
            }}

            validate={values => {

                let errors = {
                    empty: {},
                    validated: {}
                };

                if (!verifReCaptcha) {
                    errors.validated.verifReCaptcha = true;
                }

                if (!values.NombReclamante) {
                    errors.empty.NombReclamante = true;
                }

                if (!values.RUTReclamante) {
                    errors.empty.RUTReclamante = true;
                }

                if (!values.TelefReclamante && !values.CelularReclamanete) {
                    errors.empty.telCelReclamante = true;
                }

                if (!values.Observacion) {
                    errors.empty.Observacion = true;
                }

                if (values.CdgTipoReclamo === "0") {
                    errors.empty.CdgTipoReclamo = true;
                }

                if (values.RUTReclamante && !isRutValid(values.RUTReclamante)) {
                    errors.validated.RUTReclamante = true;
                }

                if (values.EmailReclamante && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.EmailReclamante)) {
                    errors.validated.EmailReclamante = true;
                }

                if (values.TelefReclamante && !/^[0-9]{9}$/i.test(values.TelefReclamante)) {
                    errors.validated.TelefReclamante = true;
                }

                if (values.CelularReclamanete && !/^[0-9]{9}$/i.test(values.CelularReclamanete)) {
                    if (!/^[0-9]{10}$/i.test(values.CelularReclamanete)) {
                        errors.validated.CelularReclamanete = true;
                    }
                }

                if (Object.keys(errors?.empty)?.length > 0) {
                    setEmptyInput(true);
                } else {
                    setEmptyInput(false);
                }

                if (Object.keys(errors?.validated)?.length > 0) {
                    setValidatedInput(true);
                } else {
                    setValidatedInput(false);
                }

                if (Object.keys(errors?.validated)?.length === 0 && Object.keys(errors?.empty)?.length === 0) {
                    errors = {};
                }

                return errors;
            }}

            onSubmit={(values, { setSubmitting }) => {
                setForm(values);

                if (buttonHandleClick) {
                    setButtonHandleClick(false)
                }
            }}

        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <CGE.Panel
                    title="Formulario de Contingencia"
                    description="Si la compañía no es responsable de la interrupción, la solicitud podría tener un costo asociado."
                    >
                    <form onSubmit={handleSubmit}>
                        <CGE.PanelSection title="1. Antecedentes">
                            <CGE.DetailClient
                                props={{
                                    handleChange: handleChange,
                                    idClient: values.CuentaContrato,
                                    idFormElement: "numberClient",
                                    labelName: "Número de Cliente:",
                                    placeholder: "Número de Cliente",
                                    mandatoryElement: true,
                                    valuePub: values.CuentaContrato,
                                    readOnly: true,
                                    propsLabelInfoContent: propsLabelInfoContent
                                }}
                                propsDetail={{
                                    fullNameClient: "",
                                    comunaClient: values.Comuna ? values.Comuna : "",
                                    calleClient: values.Calle ? values.Calle : "",
                                    nCalleClient: values.NroCalle ? values.NroCalle : "",
                                    dptoBlockClient: values.Dpto ? values.Dpto : "",
                                    ctaCtoClient: values.CuentaContrato
                                }}
                            />
                            <div class="row ">
                                <div class="col-md-12 mt-4">
                                    <CGE.Heading
                                        text="Reclamante"
                                        size="4"
                                    />
                                </div>
                                <div class="col-md-9">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError={errors?.validated?.NombReclamante || (errors?.empty?.NombReclamante && buttonHandleClick)}
                                        msgError={"Introduzca un nombre o Razón Social válida"}
                                        idFormElement="NombReclamante"
                                        labelName="Nombre o Razón Social"
                                        mandatoryElement={true}
                                        readOnly={false}
                                        typeElement="input"
                                        typeFormElement="text"
                                        value={values.NombReclamante}
                                    />
                                    <CGE.Text
                                        className="mb-0"
                                        infoLabel={true}
                                        text="* Se debe llenar los siguientes datos obligatorios (*)"
                                        size="2"
                                    />
                                </div>
                                <div class="col-md-3">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError=
                                        {
                                            errors?.validated?.RUTReclamante ||
                                            (errors?.empty?.RUTReclamante && buttonHandleClick)
                                        }
                                        msgError={"Debes ingresar un RUT válido."}
                                        idFormElement="RUTReclamante"
                                        labelName="RUT"
                                        mandatoryElement={true}
                                        maxLength="12"
                                        typeElement="input-mask"
                                        typeFormElement="text"
                                        value={values.RUTReclamante}
                                        beforeMaskedValueChange={beforeMaskedValueChangeRut}
                                        formatChars={{
                                            "9": "[0-9]",
                                            k: "[Kk0-9]",
                                        }}
                                        mask="9.999.999-kk"
                                        maskChar={null}
                                    />
                                </div>
                                <div class="col-md-12 mt-4">
                                    <CGE.Heading
                                        text="Dirección Postal"
                                        size="4"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError={errors?.validated?.EmailReclamante}
                                        msgError={"Introduzca un email válido"}
                                        idFormElement="EmailReclamante"
                                        labelName="Email"
                                        typeElement="input"
                                        typeFormElement="text"
                                        value={values.EmailReclamante}
                                    />
                                    <CGE.Text
                                        className={(errors?.empty?.telCelReclamante && buttonHandleClick) ? "mb-0 text-danger font-weight-bold" : "mb-0"}
                                        infoLabel={true}
                                        text="* Email es opcional y es obligatorio ingresar el telefono o el celular"
                                        size="2"
                                    />
                                </div>
                                <div class="col-md-3">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError={errors?.validated?.TelefReclamante}
                                        msgError={"Introduzca un Teléfono válido"}
                                        idFormElement="TelefReclamante"
                                        labelName="Teléfono"
                                        typeElement="input-mask"
                                        maxLength="9"
                                        formatChars={{
                                            9: "[0-9]"
                                        }}
                                        mask="999999999"
                                        typeFormElement="text"
                                        value={values.TelefReclamante}
                                    />
                                    {errors?.empty?.telCelReclamante && buttonHandleClick &&
                                        <CGE.Text
                                            className="mb-0 text-danger font-weight-bold"
                                            infoLabel={true}
                                            text="Introduzca al menos un número de contacto"
                                            size="2"
                                        />
                                    }
                                </div>
                                <div class="col-md-3">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError={errors?.validated?.CelularReclamanete}
                                        msgError={"Introduzca un Celular válido"}
                                        idFormElement="CelularReclamanete"
                                        labelName="Celular"
                                        typeElement="input-mask"
                                        maxLength="9"
                                        formatChars={{
                                            9: "[0-9]"
                                        }}
                                        mask="999999999"
                                        typeFormElement="text"
                                        value={values.CelularReclamanete}
                                    />
                                </div>
                            </div>
                        </CGE.PanelSection>

                        <CGE.PanelSection title="2. Materia de la presentación" >
                            <div class="row">
                                <div class="col-md-12">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError={errors?.empty?.CdgTipoReclamo && buttonHandleClick}
                                        idFormElement="CdgTipoReclamo"
                                        labelName="Tipo de Presentación"
                                        listOptions={optionsPresentacion}
                                        mandatoryElement={true}
                                        typeElement="select"
                                        typeFormElement="text"
                                        value={values.CdgTipoReclamo}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <CGE.FormsField
                                        handleChange={handleChange}
                                        hasError={errors?.empty?.Observacion && buttonHandleClick}
                                        idFormElement="Observacion"
                                        labelName="Descripción"
                                        mandatoryElement={true}
                                        numberOfRows="5"
                                        maxLength="1000"
                                        typeElement="textarea"
                                        value={values.Observacion}
                                    />
                                    <CGE.Text
                                        infoLabel={true}
                                        size="2"
                                        text={
                                            <>
                                                Quedan {1000 - values.Observacion.length} caracteres
                                            </>
                                        }
                                    />
                                </div>
                                <div className="col-md-12">
                                    <CGE.FieldRecaptcha
                                        onChange={onChangeReCaptcha}
                                        sitekey={properties.api_key_recaptcha}
                                    />
                                </div>
                                <div className="col-md-12" >
                                    {showLoad && <Loading />}
                                </div>
                                <div class="col-md-12">
                                    <div className="d-flex justify-content-between">
                                        <CGE.Button
                                            className="mr-3"
                                            label="Volver"
                                            onClick={() => funcClick(0)}
                                            type="secondary"
                                        />
                                        <CGE.Button
                                            label="Enviar"
                                            onClick={handleClickButton}
                                            type="primary"
                                        />
                                    </div>
                                </div>
                            </div>
                        </CGE.PanelSection>
                    </form>
                </CGE.Panel>
            )}
        </Formik>
    );
};

export default FormContingency;